import React, { useState } from "react";
import InputWrapper, { inputButtonStyle } from "../input/inputWrapper";
import { ButtonBase, ClickAwayListener } from "@mui/material";
import { DropdownOptions } from "../dropdownOptions";
import { MultiSelectedOptions } from "./MultiSelectedOptions";
import { MultiDropdownOptions, MultiOptions } from "./MultiDropdownOptions";
import { DropdownAnchor } from "./DropdownAnchor";
import { DISPLAY, SPACING } from "../../Constants/Enums/styles.enum";
import { Colors } from "../../Constants/colors";
import { DropdownWrapper } from "./DropdownWrapper";

interface Props {
  label: string;
  selectedOptions: DropdownOptions[] | null;
  // options: DropdownOptions[];
  allOptions: MultiOptions[];
  setOptions: (options: DropdownOptions[]) => unknown;
  validationOnClick?: () => boolean;
  errorMessage?: string;
}
export const MultiSelectDropdown = ({
  label,
  selectedOptions,
  allOptions,
  setOptions,
  validationOnClick,
  errorMessage,
}: Props) => {
  const handleRemoveOption = (optionToRemove: DropdownOptions) => {
    let updatedOption = selectedOptions || [];
    updatedOption = (selectedOptions || []).filter(
      ({ value }) => value !== optionToRemove?.value
    );

    setOptions(updatedOption);
  };

  const handleOptionSelected = (currentSelectedOption: DropdownOptions) => {
    const selectedOptionIndex = (selectedOptions || []).findIndex(
      ({ value }) => value === currentSelectedOption.value
    );

    const isOptionAlreadySelected = selectedOptionIndex >= 0;

    let updatedOption = selectedOptions || [];
    if (isOptionAlreadySelected) {
      handleRemoveOption(currentSelectedOption);
      return;
    }
    updatedOption = [...updatedOption, currentSelectedOption];

    setOptions(updatedOption);
  };

  return (
    <div>
      <InputWrapper
        label={label}
        wrapperStyle={{
          position: "relative",
        }}
        infoMessage={errorMessage}
      >
        <DropdownWrapper
          onClick={(cb) => {
            if (validationOnClick) {
              if (!validationOnClick()) {
                return;
              }
            }
            cb();
          }}
        >
          {({ isDropdownClicked, setDropdownClicked }) => (
            <>
              <MultiSelectedOptions
                selectedOptions={selectedOptions}
                onOptionRemoved={handleRemoveOption}
              />
              <MultiDropdownOptions
                selectedOptions={selectedOptions}
                dropdownOptions={allOptions}
                showDropdown={isDropdownClicked}
                onOptionsSelected={handleOptionSelected}
                setOptions={setOptions}
              />
            </>
          )}
        </DropdownWrapper>
      </InputWrapper>
    </div>
  );
};
